import axios from "axios";
import React, { useEffect, useState } from "react";
import config from "../../config";
import vAdminformat from "../../adminFormat";
import { headers } from "../../token";
import { Link } from "react-router-dom";
import { use } from "react";


const ApiMetalPrice = () => {

    const server_backend = config.API_URL;
    const [MetalList, setMetalList] = useState([]);
    const [filtersEnabled, setFiltersEnabled] = useState(false);
    const [filterBy, setFilterBy] = useState("");
    const [filterStatus, setFilterStatus] = useState(0);
    const [filterValue, setFilterValue] = useState("");

    useEffect(() => {
        const getMetal = async () => {
            try {
                const response = await axios.post(`${server_backend}/materials/types/allprice`, {
                    date_price: "2025-02-18"
                }, headers);
                //console.log("Unexpected error, please check")
                if (response.data.RES_CODE === "00") {
                    setMetalList(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        }
        getMetal();
    }, []);

    const UpdateLastPrice = async () => {
        try {
            const response = await axios.post(`${server_backend}/materials/types/allprice`, {
                    date_price: "2025-02-19"
            }, headers);

            if (response.data.RES_CODE === "00") {
                setMetalList(response.data.RES_RESULT);
            }
        } catch (error) {
            console.log("Unexpected error, please check")
        }
    }


    const handleFiltersToggle = () => {
        setFiltersEnabled(!filtersEnabled);
    }
    const handleFilterByChange = (e) => {
        setFilterBy(e.target.value);
    }
    const handleFilterStatusChange = (e) => {
        setFilterStatus(e.target.value);
    }
    const handleFilterValueChange = (e) => {
        setFilterValue(e.target.value);
    }

    useEffect(() => {
        FilterMetal();
    }, [filterValue]);

    const FilterMetal = async () => {

        const master = MetalList.filter(item => item.name == filterValue);
        console.log("Unexpected error, please check")

        /* setMetalList((prev) => {
             return prev.filter((item) => {
                 if (filterBy === "name") {
                     return item.name.toLowerCase().includes(filterValue.toLowerCase());
                 } else if (filterBy === "comment") {
                     return item.comment.toLowerCase().includes(filterValue.toLowerCase());
                 }
                 return true;
             });
         }
         ); */
    };

    return (
        <div className="page-content" data-simplebar-track="secondary" data-simplebar="init" style={{ overflow: "auto" }}>
            <div className="container-fluid">
                <div className="card">
                    <div className="card-header border-0">
                        <div className="d-flex align-items-center">
                            <h5 className="card-title mb-0 flex-grow-1">Api Metal Price</h5>
                            <div className="col-xxl-1 col-sm-2" style={{ paddingRight: "2px" }}>
                                <button type="button" className="btn btn-primary w-100" onClick={handleFiltersToggle}>
                                    <i className="ri-equalizer-fill me-1 align-bottom"></i> Filters
                                </button>
                            </div>
                            {/* <div className="flex-shrink-0">
                                <Link className="btn btn-danger add-btn" to="/create-metal-types">
                                    <i className="ri-add-line align-bottom me-1"></i> Create
                                </Link>
                            </div> */}
                        </div>
                    </div>
                    {filtersEnabled && (
                        <div className="card-body border border-dashed border-end-0 border-start-0">
                            <div className="row g-3">
                                <div className="col-4">
                                    <div className="input-light">
                                        <select
                                            className="form-control custom-select-style"
                                            name="choices-single-default"
                                            disabled={!filtersEnabled}
                                            value={filterBy} //Change to filterby
                                            onChange={handleFilterByChange}
                                        >
                                            <option value="">Filter by</option>
                                            <option value="name">Name</option>
                                            <option value="comment">Code</option>
                                        </select>

                                    </div>
                                </div>
                                <div className="col-4">
                                    <div className="input-light">
                                        <select
                                            className="form-control custom-select-style"
                                            data-choices
                                            data-choices-search-false
                                            name="choices-single-default"
                                            id="idFilterStatus"
                                            disabled={!filtersEnabled}
                                            onChange={handleFilterStatusChange}
                                        >
                                            <option value={0}>Filter status</option>
                                            <option value={1}>ACTIVATED</option>
                                            <option value={2}>DISABLED</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="search-box">
                                        <input
                                            type="text"
                                            className="form-control search"
                                            placeholder="Search for tasks or something..."
                                            disabled={!filtersEnabled}
                                            onChange={handleFilterValueChange}
                                        />
                                        <i className="ri-search-line search-icon"></i>
                                    </div>
                                </div>

                            </div>

                        </div>
                    )}
                    <div className="card-body">
                        <div
                            className="table-responsive table-card mb-4"
                            style={{ minHeight: "60vh", display: "flex", flexDirection: "column" }}
                        >
                            <table className="table align-middle table-nowrap mb-0" id="tasksTable">
                                <thead className="table-light text-muted">
                                    <tr>
                                        <th className="th-hover" >ID</th>
                                        <th className="th-hover" >Name</th>
                                        <th className="th-hover" >Code</th>
                                        <th className="th-hover" >Last Price</th>
                                        <th className="th-hover" >Last Update</th>
                                    </tr>
                                </thead>

                                <tbody className="list form-check-all">
                                    {MetalList.map((Metal_L) => (
                                        <tr key={Metal_L.secuencia}>
                                            <th scope="row">
                                                <div className="form-check">
                                                    {Metal_L.secuencia}
                                                </div>
                                            </th>

                                            <td className="due_date">{Metal_L.iso_code}</td>
                                            <td className="due_date">{Metal_L.iso_code}</td>
                                            <td className="due_date">{parseFloat(Metal_L.price1).toFixed(2) || 0}</td>
                                            <td className="date_lastprice">{vAdminformat.FormatDateTime(Metal_L.date_price)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="row g-0 text-center text-sm-start">
                            <div className="col-sm-6">
                            </div>
                            <div className="col-sm-6">
                                <div className="pagination-block pagination pagination-separated justify-content-center justify-content-sm-end mb-sm-0">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )

}

export default ApiMetalPrice;